import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el material después de comprar?',
  a: 'Al confirmar el pago en Mercado Pago, recibís un email automático con el link de acceso al material en PDF. Tardás menos de 5 minutos en tenerlo todo descargado.'
}, {
  q: '¿Sirve si recién empiezo a trabajar en domicilio o es solo para TO con experiencia?',
  a: 'Sirve para ambos. Los protocolos están graduados y tienen instrucciones paso a paso, así que recién recibidos pueden seguirlos sin perderse. Y los TO con experiencia encuentran sistematización y rigor.'
}, {
  q: '¿Necesito equipamiento especializado o me alcanza con lo que hay en el hogar del paciente?',
  a: 'Te alcanza con lo que hay en el hogar. Todo el banco de actividades está diseñado pensando en materiales accesibles: objetos cotidianos, mobiliario común y productos de apoyo económicos disponibles en Argentina.'
}, {
  q: '¿Los 6 bonos están incluidos en las dos ofertas?',
  a: 'Sí. Tanto el Megapack Base como el PRO incluyen los 6 bonos clínicos completos sin costo extra.'
}, {
  q: '¿Sirve para pacientes en institución además de domicilio?',
  a: 'Sí. Los protocolos están pensados para domicilio pero son 100% aplicables en geriátricos, centros de día y residencias. La diferencia es el entorno, no la intervención.'
}, {
  q: '¿Sirve si mis pacientes tienen otras condiciones además de Parkinson?',
  a: 'Sí. El sistema cubre Parkinsonismos atípicos, Demencia con Cuerpos de Lewy, PSP, AMS, deterioro cognitivo, temblor esencial e inestabilidad postural. Es un marco de trabajo neurodegenerativo general.'
}, {
  q: '¿Qué diferencia tiene con los recursos gratuitos que hay en internet?',
  a: 'Sistema integrado y secuenciado, no tips sueltos. Cada tomo se conecta con el siguiente, hay planillas reales para evaluar progreso, modelos para obras sociales argentinas y un protocolo clínico que respalda tus decisiones.'
}, {
  q: '¿Por qué elegir la oferta PRO y no la base?',
  a: 'El PRO suma el módulo de Abordaje Interdisciplinario (coordinar con kine, fono y neuro) y el de Gestión Profesional (honorarios, cartera, PAMI). Si querés escalar tu práctica o trabajar en equipo, el PRO te da las herramientas que faltan.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. Tenés 7 días desde la compra para pedir el reembolso completo sin preguntas. Escribís a contacto@mundodigitalarg.com y te devolvemos el 100% del dinero.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-12 md:py-20 bg-cream" data-id="element-73">
      <div className="max-w-3xl mx-auto px-4" data-id="element-74">
        <div className="text-center mb-8 md:mb-12" data-id="element-75">
          <div className="inline-flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-teal/10 rounded-full mb-3" data-id="element-76">
            <HelpCircle className="w-5 h-5 md:w-6 md:h-6 text-teal" data-id="element-77" />
          </div>
          <h2 className="text-[11px] md:text-sm font-bold text-teal tracking-widest uppercase mb-1 md:mb-2" data-id="element-78">
            DUDAS COMUNES
          </h2>
          <h3 className="text-2xl md:text-4xl font-extrabold text-navy" data-id="element-79">
            PREGUNTAS FRECUENTES
          </h3>
        </div>

        <div className="space-y-2 md:space-y-3" data-id="element-80">
          {faqs.map((item, i) => <div key={i} className={`bg-white border rounded-xl overflow-hidden shadow-sm transition-all ${openIndex === i ? 'border-teal/40 shadow-md' : 'border-gray-200'}`} data-id="element-81">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-4 md:px-6 py-3 md:py-4 text-left flex justify-between items-center focus:outline-none gap-3" aria-expanded={openIndex === i} data-id="element-82">
                <span className={`font-bold text-sm md:text-base leading-tight pr-2 ${openIndex === i ? 'text-teal' : 'text-navy'}`} data-id="element-83">
                  {item.q}
                </span>
                <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-teal flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-84" />
              </button>

              <AnimatePresence data-id="element-85">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25
            }} data-id="element-86">
                    <div className="px-4 md:px-6 pb-3 md:pb-4 text-gray-600 text-xs md:text-sm leading-relaxed border-t border-gray-50 pt-3 md:pt-4" data-id="element-87">
                      {item.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};